module.exports = __webpack_public_path__ + "img/module_bot.7e231193.jpg";